(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-program"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatCurrency = (value) => new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(Number.isFinite(value) ? value : 0);

    document.querySelectorAll('[data-affiliate-calculator]').forEach((calculator) => {
      const ordersInput = calculator.querySelector('[data-calculator-orders]');
      const averageInput = calculator.querySelector('[data-calculator-average]');
      const rateInput = calculator.querySelector('[data-calculator-rate]');
      const monthlyOutput = calculator.querySelector('[data-calculator-monthly]');
      const salesOutput = calculator.querySelector('[data-calculator-sales]');
      const annualOutput = calculator.querySelector('[data-calculator-annual]');

      if (!ordersInput || !averageInput || !rateInput) return;

      const update = () => {
        const orders = Math.max(0, Number(ordersInput.value) || 0);
        const average = Math.max(0, Number(averageInput.value) || 0);
        const rate = Math.max(0, Number(rateInput.value) || 0) / 100;
        const sales = orders * average;
        const monthly = sales * rate;

        monthlyOutput.textContent = formatCurrency(monthly);
        salesOutput.textContent = formatCurrency(sales);
        annualOutput.textContent = formatCurrency(monthly * 12);
      };

      [ordersInput, averageInput, rateInput].forEach((input) => input.addEventListener('input', update));
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storefront-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializeFlyingDoveEditorial = (root = document) => {
    const revealItems = root.querySelectorAll('.fd-reveal:not([data-fd-reveal-ready])');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealItems.forEach((item) => {
      item.dataset.fdRevealReady = 'true';
      revealObserver.observe(item);
    });

    const reviewCarousels = root.querySelectorAll('[data-review-carousel]:not([data-review-carousel-ready])');
    reviewCarousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-review-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-review-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-review-dot]'));
      const previous = carousel.querySelector('[data-review-previous]');
      const next = carousel.querySelector('[data-review-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = 0;
      let autoplayTimer;
      let scrollFrame;

      carousel.dataset.reviewCarouselReady = 'true';
      if (!track || slides.length < 2) return;

      const updateDots = () => {
        dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
        });
      };

      const goToSlide = (targetIndex) => {
        activeIndex = (targetIndex + slides.length) % slides.length;
        track.scrollTo({ left: track.clientWidth * activeIndex, behavior: reducedMotion ? 'auto' : 'smooth' });
        updateDots();
      };

      const stopAutoplay = () => window.clearInterval(autoplayTimer);
      const startAutoplay = () => {
        stopAutoplay();
        if (!reducedMotion) autoplayTimer = window.setInterval(() => goToSlide(activeIndex + 1), 6000);
      };

      previous?.addEventListener('click', () => {
        goToSlide(activeIndex - 1);
        startAutoplay();
      });
      next?.addEventListener('click', () => {
        goToSlide(activeIndex + 1);
        startAutoplay();
      });
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goToSlide(Number(dot.dataset.reviewDot));
          startAutoplay();
        });
      });
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const nextIndex = Math.round(track.scrollLeft / track.clientWidth);
          if (nextIndex !== activeIndex && slides[nextIndex]) {
            activeIndex = nextIndex;
            updateDots();
          }
        });
      }, { passive: true });
      carousel.addEventListener('pointerenter', stopAutoplay);
      carousel.addEventListener('pointerleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) startAutoplay();
      });
      startAutoplay();
    });

    const subscriberPopups = root.querySelectorAll('[data-subscriber-popup]:not([data-subscriber-popup-ready])');
    subscriberPopups.forEach((popup) => {
      const closeButtons = popup.querySelectorAll('[data-subscriber-popup-close]');
      const emailField = popup.querySelector('input[type="email"]');
      const success = popup.dataset.subscriptionSuccess === 'true';
      const hasError = popup.dataset.subscriptionError === 'true';
      const storageKey = 'flying-dove-subscriber-popup-dismissed';
      let dismissed = false;

      popup.dataset.subscriberPopupReady = 'true';
      try {
        dismissed = window.sessionStorage.getItem(storageKey) === 'true';
      } catch (error) {
        dismissed = false;
      }

      const rememberDismissal = () => {
        try {
          window.sessionStorage.setItem(storageKey, 'true');
        } catch (error) {
          return;
        }
      };

      const closePopup = () => {
        rememberDismissal();
        if (popup.open) popup.close();
      };

      const openPopup = () => {
        if (popup.open || typeof popup.showModal !== 'function') return;
        popup.showModal();
        window.requestAnimationFrame(() => emailField?.focus({ preventScroll: true }));
      };

      closeButtons.forEach((button) => button.addEventListener('click', closePopup));
      popup.addEventListener('click', (event) => {
        if (event.target === popup) closePopup();
      });
      popup.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePopup();
      });

      if (success || hasError) {
        openPopup();
      } else if (!dismissed) {
        window.setTimeout(openPopup, Number(popup.dataset.popupDelay) || 5000);
      }
    });
  };
  initializeFlyingDoveEditorial();
  document.addEventListener('shopify:section:load', (event) => initializeFlyingDoveEditorial(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
